<script>
import { multicurrencyMixin } from '@/mixins/offices';

import { capitalize } from '@/helpers';

export default {
  name: 'common-tariffs-table-column',
  mixins: [multicurrencyMixin],
  props: {
    steps: Array,
    price: Number,
    planRecordId: Number,
    isPriceColumn: Boolean,
    currentCurrencySymbol: String
  },
  computed: {
    getCurrency() {
      if (this.planRecordId) {
        if (this.steps.length == 1) {
          return `${this.steps[0].price.toFixed(4)} ${!this.isM11yOfficeMixin ? this.currentCurrencySymbol : ''}`;
        } else {
          return capitalize(
            this.$t('fe.price.from', [
              `${this.steps[0].price.toFixed(4)} ${!this.isM11yOfficeMixin ? this.currentCurrencySymbol : ''}`
            ])
          );
        }
      } else {
        return `${this.price.toFixed(4)} ${!this.isM11yOfficeMixin ? this.currentCurrencySymbol : ''}`;
      }
    }
  }
};
</script>

<template>
  <div>
    <template v-if="isPriceColumn">
      {{ $numberWithSpaces(getCurrency) }}
    </template>
  </div>
</template>
